import { render, staticRenderFns } from "./goodsRow.vue?vue&type=template&id=7344a84e&scoped=true"
import script from "./goodsRow.vue?vue&type=script&lang=js"
export * from "./goodsRow.vue?vue&type=script&lang=js"
import style0 from "./goodsRow.vue?vue&type=style&index=0&id=7344a84e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7344a84e",
  null
  
)

export default component.exports